class PackPicker extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this.handleChange);
    this.syncSelection();
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.handleChange);
  }

  handleChange = (event) => {
    if (!(event.target instanceof HTMLInputElement)) return;
    if (event.target.type !== 'radio') return;

    this.syncSelection();
  };

  syncSelection() {
    const selectedInput = this.querySelector('input[type="radio"]:checked');
    if (!(selectedInput instanceof HTMLInputElement)) return;

    this.updateVariantInput(selectedInput);
    this.updatePrice(selectedInput);
    this.updateAcceleratedCheckout(selectedInput);
    this.updateQuantityCartCount(selectedInput);
  }

  updateVariantInput(selectedInput) {
    const variantInput = this.form?.querySelector('input[name="id"][ref="variantId"]');
    const variantId = selectedInput.dataset.packVariantId;

    if (!(variantInput instanceof HTMLInputElement) || !variantId) return;

    if (variantInput.value !== variantId) {
      variantInput.value = variantId;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  updatePrice(selectedInput) {
    const priceBlock = this.priceBlock;
    const selectedPrice = selectedInput.dataset.packPrice;

    if (!priceBlock || !selectedPrice) return;

    priceBlock.setAttribute('aria-live', 'polite');

    const priceContainer = priceBlock.querySelector('[ref="priceContainer"]');
    const regularPrice = priceContainer?.querySelector('.price__regular .price') || priceContainer?.querySelector('.price');
    const regularContainer = priceContainer?.querySelector('.price__regular');
    const saleContainer = priceContainer?.querySelector('.price__sale');

    if (regularPrice) regularPrice.textContent = selectedPrice;
    regularContainer?.classList.remove('price__hidden');
    saleContainer?.classList.add('price__hidden');

    let saveNote = priceBlock.querySelector('[data-pack-picker-price-save]');

    if (!saveNote && regularPrice) {
      saveNote = document.createElement('span');
      saveNote.className = 'tl-pack-picker-price-save';
      saveNote.dataset.packPickerPriceSave = 'true';
      regularPrice.insertAdjacentElement('afterend', saveNote);
    }

    if (saveNote) {
      saveNote.textContent = selectedInput.dataset.packSave || this.dataset.saveText || '';
      saveNote.hidden = selectedInput.value !== 'mates';
    }
  }

  updateAcceleratedCheckout(selectedInput) {
    const acceleratedCheckout = this.productForm?.querySelector('[ref="acceleratedCheckoutButtonContainer"]');

    if (!(acceleratedCheckout instanceof HTMLElement)) return;

    if (!acceleratedCheckout.dataset.packPickerInitialHidden) {
      acceleratedCheckout.dataset.packPickerInitialHidden = acceleratedCheckout.hidden ? 'true' : 'false';
    }

    const initialHidden = acceleratedCheckout.dataset.packPickerInitialHidden === 'true';
    const shouldHide = initialHidden || selectedInput.value === 'mates';

    acceleratedCheckout.hidden = shouldHide;

    if (shouldHide) {
      acceleratedCheckout.setAttribute('aria-hidden', 'true');
    } else {
      acceleratedCheckout.removeAttribute('aria-hidden');
    }
  }

  updateQuantityCartCount(selectedInput) {
    const quantitySelector = this.productForm?.querySelector('quantity-selector-component');
    const quantityInput = quantitySelector?.querySelector('input[ref="quantityInput"]');
    const variantId = selectedInput.dataset.packVariantId;

    if (!variantId) return;

    fetch('/cart.js')
      .then((response) => (response.ok ? response.json() : null))
      .then((cart) => {
        if (!cart?.items) return;

        const cartItem = cart.items.find((item) => item.variant_id?.toString() === variantId);
        const cartQuantity = cartItem?.quantity || 0;

        if (typeof quantitySelector?.setCartQuantity === 'function') {
          quantitySelector.setCartQuantity(cartQuantity);
        } else if (quantityInput instanceof HTMLInputElement) {
          quantityInput.dataset.cartQuantity = cartQuantity.toString();
        }
      })
      .catch(() => {});
  }

  get form() {
    return this.closest('form');
  }

  get productForm() {
    return this.closest('product-form-component');
  }

  get priceBlock() {
    const section = this.closest('.shopify-section') || document;
    const priceBlockId = this.dataset.priceBlockId;
    const priceBlockSelector = priceBlockId ? `product-price[data-block-id="${priceBlockId}"]` : 'product-price';

    return section.querySelector(priceBlockSelector) || section.querySelector('product-price');
  }
}

if (!customElements.get('pack-picker')) {
  customElements.define('pack-picker', PackPicker);
}
